import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Tooltip, Typography } from '@mui/material';

import RequiredIndicator from '../RequiredIndicator';

const AdditionalContactInfo = ({
  title,
  value,
  hasError,
  errorHelperText,
}: {
  title: string;
  value: string | null | undefined;
  hasError?: boolean;
  errorHelperText?: string;
}) => {
  const hasDetailedError = (errorHelperText?.trim().length ?? 0) > 0;
  const invalidTooltipText = hasDetailedError ? `${errorHelperText}` : 'Invalid value';

  return (
    <Box sx={{}}>
      <Typography
        variant='overline2'
        component='p'
        sx={{ marginBottom: '4px', color: 'text.secondary' }}
      >
        {title}
      </Typography>
      {value != null ? (
        <Box>
          <Typography
            component='span'
            sx={{
              overflowWrap: 'anywhere',
              color: hasError ? 'error.main' : 'text.secondary',
            }}
          >
            {value}
          </Typography>
          {hasError && (
            <Tooltip title={invalidTooltipText} arrow>
              <Box
                component='span'
                sx={{
                  marginLeft: '4px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  color: 'error.main',
                }}
              >
                <ErrorOutlineIcon aria-label='Invalid field details' sx={{ fontSize: 16 }} />
              </Box>
            </Tooltip>
          )}
        </Box>
      ) : (
        <Typography color='error' component='span'>
          Required <RequiredIndicator />
        </Typography>
      )}
    </Box>
  );
};

export default AdditionalContactInfo;
